import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { WINDOW_PROVIDERS } from "@webapp/core/util/factories/window.factory";
import { AccountIdHeaderInterceptor } from "@webapp/core/http/interceptors/account-id-header.interceptor";
import { AuthTokenInterceptor } from "@webapp/core/http/interceptors/auth-token.interceptor";
import { CdnRewriteInterceptor } from "@webapp/core/http/interceptors/cdn-rewrite.interceptor";
import { DisableApiRequestCacheInterceptor } from "@webapp/core/http/interceptors/disable-api-request-cache.interceptor";
import { TrackDataInterceptor } from "@webapp/core/http/interceptors/track-data.interceptor";
import { HttpErrorInterceptor } from "@webapp/core/http/interceptors/http-error.interceptor";
import { AccountSuspendedInterceptor } from "@webapp/core/http/interceptors/account-suspended.interceptor";
import { DestroyService } from "@webapp/core/util/services/destroy.service";
import { AuthenticationResolverServiceProvider } from "@webapp/authentication/providers/authentication-resolver.provider";
import { UserProfileServiceProvider } from "@webapp/users/providers/user-profile.provider";
import { providerUpgradeFactory } from "@webapp/core/provider-upgrade/factories/provider-upgrade.factory";
import { LocalizePipe } from "@webapp/core/localization/localize.pipe";
import { ClipboardService } from "./util/services/clipboard.service";

@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [LocalizePipe],
  exports: [LocalizePipe],
  providers: [
    AuthenticationResolverServiceProvider,
    UserProfileServiceProvider,
    DestroyService,
    ClipboardService,
    ...WINDOW_PROVIDERS,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccountIdHeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CdnRewriteInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DisableApiRequestCacheInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TrackDataInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccountSuspendedInterceptor,
      multi: true,
    },
    {
      provide: "$rootScope",
      useFactory: providerUpgradeFactory("$rootScope"),
      deps: ["$injector"],
    },
    /* TODO: expected to migrate:
     * HandleUnauthorizedResponseInterceptor
     * RetryFailedResponseInterceptor (this should be handled by the http-error interceptor already
     *
     */
  ],
})
export class CoreModule {}
